import React from "react";

function CategorySection() {
	return (
		<div>
			<h1>This is CategorySection</h1>
		</div>
	);
}

export default CategorySection;
